import { GCounter, mergeGCounters } from "./gCounter.js";
import { LWWMap, mergeLWWMap } from "./lwwMap.js";
import { ORMap, mergeORMap } from "./orMap.js";

export interface CrdtState {
  clock: GCounter;
  wallet_profile: LWWMap;
  personas: ORMap;
  devices: ORMap;
  preferences: LWWMap;
}

export function emptyCrdtState(): CrdtState {
  return {
    clock: {},
    wallet_profile: {},
    personas: {},
    devices: {},
    preferences: {},
  };
}

export function crdtMerge(local: CrdtState, remote: CrdtState): CrdtState {
  return {
    clock: mergeGCounters(local.clock, remote.clock),
    wallet_profile: mergeLWWMap(local.wallet_profile, remote.wallet_profile),
    personas: mergeORMap(local.personas, remote.personas),
    devices: mergeORMap(local.devices, remote.devices),
    preferences: mergeLWWMap(local.preferences, remote.preferences),
  };
}

export function canonicalize(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(canonicalize);
  }
  if (value && typeof value === "object") {
    const obj = value as Record<string, unknown>;
    const sorted: Record<string, unknown> = {};
    for (const key of Object.keys(obj).sort()) {
      sorted[key] = canonicalize(obj[key]);
    }
    return sorted;
  }
  return value;
}

export function canonicalCrdtBytes(state: CrdtState): Uint8Array {
  const json = JSON.stringify(canonicalize(state));
  return new TextEncoder().encode(json);
}
